import { render } from "./BookProgressField.vue?vue&type=template&id=1f307789&scoped=true"
import script from "./BookProgressField.vue?vue&type=script&lang=js"
export * from "./BookProgressField.vue?vue&type=script&lang=js"

import "./BookProgressField.vue?vue&type=style&index=0&id=1f307789&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f307789"]])

export default __exports__